import { Media } from '@/models/media.model';

export interface Category {
  id: number;
  title: string;
  tileTitle: string;
  color: string;
  emoji: string;
  media: Media[];
  parentCategory: Category | null;
  isContent: boolean;
  index: number;
}

export const titleRules = [
  (value: string) => {
    if (value) return true;

    return 'Title is required.';
  },
];
